export const HOST_PAYMENT_API = process.env.REACT_APP_PAYMENT_HOST || "";
export const HOST_CORE_API = process.env.REACT_APP_CORE_HOST || "";
export const HOST_WSS = process.env.REACT_APP_WSS_HOST || "";
export const FEE_INVOICE_LINK_URL = process.env.REACT_APP_FEE_INVOICE_LINK_URL || "";
export const ADHOC_CHARGE_LINK = process.env.REACT_APP_ADHOC_CHARGE_LINK || "";
export const SERVICE_URL = process.env.REACT_APP_SERVICE_URL || "";
export const DEFAULT_FORM_BEHAVIOUR = { mode: "onChange", reValidateMode: "onChange" } as any;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "";
export const STRIPE_PK = process.env.REACT_APP_STRIPE_PK || "";
export const TERMS_LINK = process.env.REACT_APP_TERMS_LINK || "";
export const VERSION = process.env.REACT_APP_VERSION || "";
export const BUGSNAG_KEY = process.env.REACT_APP_BUGSNAG_KEY || "";

// LAYOUT
export const HEADER = {
    MOBILE_HEIGHT: 64,
    MAIN_DESKTOP_HEIGHT: 88,
    DASHBOARD_DESKTOP_HEIGHT: 80,
    DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
    BASE_WIDTH: 260,
    DASHBOARD_WIDTH: 280,
    DASHBOARD_COLLAPSE_WIDTH: 100,
    DASHBOARD_ITEM_ROOT_HEIGHT: 48,
    DASHBOARD_ITEM_SUB_HEIGHT: 40,
    DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
    NAVBAR_ITEM: 22,
    NAVBAR_ITEM_HORIZONTAL: 20,
};
